<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <h5 class="text-center">{{ lang.label }} Section</h5>
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <fg-input type="text"
                    label="Main Heading"
                    name="main_heading"
                    fou
                    v-model="formData.main_heading">
          </fg-input>
          <fg-input type="text"
                    label="Extra Heading"
                    name="second_heading"
                    fou
                    v-model="formData.extra_heading">
          </fg-input>
          <div class="form-group">
            <label>Content</label>
            <editor
              v-model="formData.content"
              :api-key="editorKey"
              :init='editorConfig'
            />
          </div>
          <fg-input type="text"
                    label="Destination Url Title"
                    name="destination_url_title"
                    fou
                    v-model="formData.destination_url_title">
          </fg-input>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
  import { Select, Option } from 'element-ui'
  import { extend } from "vee-validate";
  import { required, email, regex } from "vee-validate/dist/rules";
  import Editor from '@tinymce/tinymce-vue'
  import FormGroupTextArea from "@/components";

  extend("required", required);
  extend("email", email);
  extend("regex", regex);

  export default {
    components: {
      FormGroupTextArea,
      [Select.name]: Select,
      [Option.name]: Option,
      'editor': Editor
    },
    props: {
      lang: {
        type: Object
      },
      editMode: {
        type: Boolean,
        default: false
      },
      isSubmit: {
        type: Boolean,
        default: false
      },
      formData:{
        type: Object,
        default() {
          return {
            group_id: "",
            name: "",
            ident: "",
            main_heading: "",
            extra_heading:"",
            content: "",
            destination_url_title: "",
            url_target: "",
          }
        }
      },
    },
    data () {
      return {
        editorConfig: this.getEditorConfig(),
        editorKey: process.env.VUE_APP_TINY_EDITOR_KEY,
      }
    },
    methods: {
      validate() {
        return this.$refs.form.validate().then(res => {
          if (res){
            this.$emit('submit-step', this.formData, this.lang.value, this.isSubmit)
          }else{
            this.$emit('on-validated', res)
          }
          return res
        });
      },
    }
  }
</script>
<style>
</style>
